export default "__VITE_ASSET__BSZV4NRH__"